import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Banner from "../components/Banner";
import TicketList from "../components/TicketList1";
import SpotifyPlaylist from "../components/SpotifyPlaylist";
import Apt300OnYoutube from "../components/Apt300OnYoutube";
import Apt300Gallery from "../components/Apt300Gallery";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const Home = () => {
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // 'success' or 'failed'
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has("success")) {
      setMessage(
        "Your order was successful. We have sent your tickets to the email provided. If you have any questions, please contact us at apt300djs@gmail.com or 4314898815"
      );
      setMessageType("success");
    } else if (params.has("failed")) {
      setMessage(
        "There may have been an issue with your order. Please try again or contact us at apt300djs@gmail.com or 4314898815"
      );
      setMessageType("failed");
    }

    if (params.has("success") || params.has("failed")) {
      const timer = setTimeout(() => {
        setMessage("");
        setMessageType("");
        window.history.replaceState({}, "", window.location.pathname);
      }, 20000);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    const alignToHashTarget = () => {
      const id = decodeURIComponent(window.location.hash.replace(/^#/, ""));
      if (!id) return;

      const target = document.getElementById(id);
      if (!target) return;
      const headerHeight = document.querySelector(".apt300-header")?.getBoundingClientRect().height || 0;
      const targetTop = window.pageYOffset + target.getBoundingClientRect().top - headerHeight - 16;
      window.scrollTo({ top: Math.max(0, targetTop), behavior: "auto" });
    };

    const scrollToHash = () => {
      const id = decodeURIComponent(window.location.hash.replace(/^#/, ""));
      if (!id) return;

      const pendingImages = Array.from(document.images).filter((image) => !image.complete);
      const imageLayoutReady = pendingImages.length === 0
        ? Promise.resolve()
        : Promise.race([
            Promise.all(pendingImages.map((image) => new Promise((resolve) => {
              image.addEventListener("load", resolve, { once: true });
              image.addEventListener("error", resolve, { once: true });
            }))),
            new Promise((resolve) => window.setTimeout(resolve, 1500)),
          ]);

      imageLayoutReady.then(() => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            alignToHashTarget();
            window.setTimeout(alignToHashTarget, 400);
          });
        });
      });
    };

    scrollToHash();
    window.addEventListener("hashchange", scrollToHash);
    return () => window.removeEventListener("hashchange", scrollToHash);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;

      setShowBackToTop(scrollTop > 200);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const messageStyle = {
    background: messageType === "failed" ? "#f2dede" : "#dff0d8",
    color: messageType === "failed" ? "#a94442" : "#3c763d",
    padding: "1rem",
    margin: "3rem",
    borderRadius: "4px",
    textAlign: "center",
  };

  return (
    <>
      {message && (
        <div className="order-message" style={messageStyle}>
          {message}
        </div>
      )}
      <Header />
      <Banner />
      <TicketList />
      <Apt300Gallery />
      <Apt300OnYoutube />
      <SpotifyPlaylist spotifyUri="YOUR_PLAYLIST_URI" />
      <ContactSection />
      <Footer />
      {showBackToTop && (
        <button
          type="button"
          className="back-to-top-button"
          onClick={handleBackToTop}
          aria-label="Back to top"
        >
          Back to top
        </button>
      )}
    </>
  );
};

export default Home;
